import React, { useEffect } from 'react';
import {GET_USER_REGISTRATS_URL} from '../../api';
import {getUserRegistrats} from '../../request/users';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import {capitalize} from "../../utils/capitalize";
import moment from "moment";

const Dashboard = () => {

    document.title = "Dashboard";

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        getUserRegistrats().then((response) => {
            $('#total-users').text(response.total);
            $('#date-current').text(response.date_current);
            $('#month-current').text(response.month_current);
            $('#daily-active').text(response.daily);
            $('#montly-active').text(response.montly);
        });

        $('#user').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting User Report</p>'
            },
            "searching": true,
            "lengthMenu": [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_USER_REGISTRATS_URL, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: res.data
                        });
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.email;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.country;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return moment(data.date).format("Do MMM, YYYY");
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data.device);
                    },
                    "targets": 3
                }
            ]
        });
    }, []);

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Users</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Users</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-4">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Registered Users</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-users" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">-</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">Since 12th June, 2019</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Active Users Today</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="daily-active" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="date-current" className="tx-11 tx-color-02 mg-b-0 mg-t-5">-</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Active Users Monthly</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="montly-active" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="month-current" className="tx-11 tx-color-02 mg-b-0 mg-t-5">-</span>
                        </div>
                    </div>

                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Total Users</h6>
                                <div className="d-flex tx-18">
                                    <a href="" className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="user" className="table">
                                    <thead>
                                    <tr>
                                        <th className="wd-30p">Email</th>
                                        <th className="wd-20p">Country</th>
                                        <th className="wd-20p">Date</th>
                                        <th className="wd-20p">Device</th>
                                    </tr>
                                    </thead>
                                </table>
                                <div className="modal fade" id="my_modal" tabIndex="-1" role="dialog" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <div className="media align-items-center">
                                                    <div className="media-body">
                                                        <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </a>
                                                        <p className="tx-13 tx-color-02 mg-b-0 tx-semibold" id="title">Error</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-body">
                                                <table id="geography" className="table tx-13 mg-b-0">
                                                    <thead>
                                                    <tr>
                                                        <th>Age Group</th>
                                                        <th>Male</th>
                                                        <th className="text-right">Female</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td>18 - 24</td>
                                                        <td id="mag1">0</td>
                                                        <td id="fag1" className="text-right">0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>25 - 34</td>
                                                        <td id="mag2">0</td>
                                                        <td id="fag2" className="text-right">0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>35 - 44</td>
                                                        <td id="mag3">0</td>
                                                        <td id="fag3" className="text-right">0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>45 and above</td>
                                                        <td id="mag4">0</td>
                                                        <td id="fag4" className="text-right">0</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Dashboard;
